module.exports = __webpack_public_path__ + "img/76338.e944cec2.svg";